export const loginSucceededAction = () => ({
    type: 'LOGIN_SUCCEEDED'
});

export const loginFailedAction = () => ({
    type: 'LOGIN_FAILED'
});


// WEBPACK FOOTER //
// ./src/actions/login.js